<form #scaleForm="ngForm" class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">Update Shoe Dispensation</h4>
    <button type="button" class="stewards-modal-close" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body">
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label class="stewards-modal-label" for="newShoeDispensation">Select a new status</label>
          <select class="custom-select" id="newShoeDispensation" name="newShoeDispensation" [(ngModel)]="selectedStatus">
            <option *ngFor="let dispensation of possibleStatuses" [value]="dispensation">{{dispensation}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
    <button type="button" class="btn btn-outline-dark stewards-modal-btn-close" (click)="cancel('cancel')">Close</button>
    <button type="button" class="btn btn-primary" [disabled]="!selectedStatus" (click)="confirm()">Confirm</button>
  </div>
  <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
    <fa name="circle-o-notch" animation="spin"></fa>
  </div>
</form>
